import React, {FC, PropsWithChildren} from 'react';

interface ButtonProps {
  onClick: any;
  bold?: boolean;
}

const CalcImageButtonComponent: FC<PropsWithChildren<ButtonProps>> = (props) => {
  return (
    <div className="flex flex-col w-full totalCenter p-2" onClick={props.onClick}>
      <div className="flex card-1 w-full h-full mRounded-2 text-center totalCenter aspect-[1/1]">
        <div className={`fs-4 ${props.bold ? 'text-bold' : ''}`}>{props.children}</div>
      </div>
    </div>
  );
};

export default CalcImageButtonComponent;
